<template>
  <div>
    <loading :active.sync="isLoading"></loading>

    <div class="app-title">
      <div>
        <h1><i class="fas fa-layer-group"></i> บทบาท</h1>
        <p>[{{ name }}]</p>
      </div>
      <ul class="app-breadcrumb breadcrumb">
        <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
        <li class="breadcrumb-item"><a href="#">Home</a></li>
      </ul>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="tile">
          <div class="tile-title-w-btn">
            <h3 class="title">บทบาททั้งหมด</h3>
            <p>
              <button
                @click="modal.show()"
                type="button"
                class="btn btn-primary"
              >
                <i class="fas fa-plus"></i> เพิ่มบทบาท
              </button>
            </p>
          </div>
          <div class="tile-body">
            <table class="table table-bordered" v-if="roles.length">
              <thead class="bg-light">
                <tr>
                  <th>#</th>
                  <th>name</th>
                  <th>manage</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in roles" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.role_name }}</td>
                  <td>
                    <div
                      class="btn-group btn-group-sm"
                      role="group"
                      aria-label="Basic mixed styles example"
                    >
                      <button
                        @click="edit(item)"
                        type="button"
                        class="btn btn-warning"
                      >
                        <i class="fas fa-edit"></i>
                      </button>
                      <button
                        @click="del(item.id)"
                        type="button"
                        class="btn btn-danger"
                      >
                        <i class="fas fa-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" ref="exampleModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">ฟอร์มเพิ่มหน่วยงาน</h5>
            <button
              @click="modal.hide()"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form
              @submit.prevent="handleSubmit"
              ref="form"
              class="needs-validation"
              novalidate
            >
              <div class="form-group">
                <label for="">ชื่อบทบาท</label>
                <input
                  v-model="data.role_name"
                  type="text"
                  class="form-control"
                  placeholder="ชื่อบทบาท"
                  required
                />
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              v-if="!is_edit"
              @click="handleSubmit"
              type="button"
              class="btn btn-primary"
            >
<i class="fas fa-save    "></i>
              บันทึกข้อมูล
            </button>
            <button
              v-else
              @click="update"
              type="button"
              class="btn btn-warning"
            >
              <i class="fas fa-edit"></i>

              แก้ไขข้อมูล
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              @click="modal.hide()"
            >
              <i class="fas fa-times"></i>

              ปิด
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";

import RolesService from "../services/roles.service";
export default {
  data() {
    return {
      modal: null,
      data: {},
      is_edit: false,
      isLoading: false,
      roles: [],
      name: this.$route.name,
      user: this.$store.state.Auth.user.user,
    };
  },
  methods: {
    clear() {
      this.data = {};
      this.modal.hide();
      this.is_edit = false;
    },
    insert() {
      RolesService.create(this.data)
        .then((res) => {
          this.showSuccess();
          this.clear();
          this.get();
        })
        .catch((err) => {});
    },
    update() {
      RolesService.update(this.data.id, this.data)
        .then((res) => {
          this.showUpdate();
          this.get();
          this.clear();
        })
        .catch((err) => {});
    },
    edit(data) {
      this.modal.show();
      this.data = data;
      this.is_edit = true;
    },
    delete(id) {
      RolesService.delete(id)
        .then((res) => {
          this.showDelete();
          this.get();
          this.clear();
        })
        .catch((err) => {});
    },
    async del(id) {
      const confirm = await this.showConfirm();
      confirm ? await this.delete(id) : false;
    },
    get() {
      RolesService.getAll()
        .then((res) => {
          this.roles = res.data;
          this.isLoading = false;
        })
        .catch((err) => {});
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      return valid;
    },
    async handleSubmit() {
      if (!this.checkFormValidity()) {
        this.$refs.form.classList.add("was-validated");
        return;
      }
      (await this.is_edit) ? this.update() : this.insert();
      await this.modal.hide();
      await this.clear();
      await this.$refs.form.classList.remove("was-validated");
    },
  },
  mounted() {
    this.modal = new Modal(this.$refs.exampleModal);
  },
  created() {
    this.isLoading = true;
    this.get();
  },
};
</script>

<style>
</style>